// Mã đơn: bấm mở TAB MỚI tới chi tiết đơn. Dùng thẻ <a> thường (full load ở tab
// mới) — không cần router context, hoạt động cả trong dialog/test. Không có
// orderId (đơn đã xoá / dòng không gắn đơn) → chỉ hiện text.
export function OrderCodeLink({
    orderId,
    code,
    className,
}: {
    orderId?: string
    code?: string
    className?: string
}) {
    const label = code || '—'
    if (!orderId) {
        return <span className={className}>{label}</span>
    }
    return (
        <a
            href={`/orders/${orderId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-primary hover:underline ${className ?? ''}`}
        >
            {label}
        </a>
    )
}
